<template>
  <div class="grid grid-cols-6 items-center gap-2">
    <slot />

    <button
      v-if="showReset"
      data-test="reset-button"
      class="text-accent hover:text-accent-hover col-span-2 col-end-7 inline-flex items-center justify-end text-sm"
      :title="t('common.clear_selections')"
      @click="resetSelections"
    >
      <LzIcon
        v-if="showReset"
        path="icons/x--small"
        size="sm"
        class="text-primary-400"
        :title="t('common.clear_selections')"
      />
      {{ t('common.reset') }}
    </button>
  </div>
</template>

<script>
import { provide, ref, watch } from 'vue'
import LzIcon from './LzIcon'
import { common } from 'vue_features/shared/i18n'
import { namespaceLocaleObj } from 'vue_features/shared/helpers/i18n_helper'
import { useI18n } from 'vue-i18n'

const DEFAULT_BUTTON_CLASSES = ['font-bold', 'cursor-pointer', 'focus:border-primary-500']

export default {
  name: 'CheckButtons',
  components: { LzIcon },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    showReset: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: [Array, String, Object],
      default: () => DEFAULT_BUTTON_CLASSES,
    },
  },
  setup(props, { emit }) {
    const selections = ref([])
    const toggle = (val) => {
      if (selections.value.includes(val)) {
        selections.value = selections.value.filter((v) => v !== val)
      } else {
        selections.value = [...selections.value, val]
      }

      emit('input', selections.value)
    }
    const resetSelections = () => {
      selections.value = []
      emit('input', selections.value)
    }

    watch(
      () => [...props.value],
      (newSelections) => {
        selections.value = newSelections
      },
      { immediate: true },
    )

    provide('name', props.name)
    provide('toggle', toggle)
    provide('selections', selections)

    const { t } = useI18n({ messages: namespaceLocaleObj(common, 'common', { only: ['reset', 'clear_selections'] }) })

    return { selections, toggle, resetSelections, t }
  },
}
</script>
